import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(() => import("../components/transcript/report/main"));

const TranscriptReport = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default TranscriptReport;